import { openBlock as t, createElementBlock as o, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
};
function l(s, e) {
  return t(), o("svg", n, [...e[0] || (e[0] = [
    r("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      d: "m15.5.5-15 15"
    }, null, -1),
    r("path", {
      stroke: "currentColor",
      d: "M.5.5h15v15H.5z"
    }, null, -1)
  ])]);
}
const a = { render: l };
export {
  a as default,
  l as render
};
